import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

import { ActiveSource, SourceTable } from 'types/GlobalSource'

import Button from 'components_new/atoms/Button'
import Text from 'components_new/atoms/Text'

import SimpleDialog from 'components_new/molecules/SimpleDialog'

import { useSourceTableActions } from 'redux/actions/DataPlatform/connections/SourceTables'

interface DeleteSourceTableDialogProps {
  activeSource: ActiveSource
  onClose: () => void
  open: boolean
  table: SourceTable | null
}

/**
 * A table that feeds an input node cannot be deleted. The backend answers with
 * a conflict, and the dialog turns into an explanation instead of a
 * confirmation.
 */
const DeleteSourceTableDialog = (props: DeleteSourceTableDialogProps) => {
  const { activeSource, onClose, open, table } = props

  const history = useHistory()
  const { tryDeleteSourceTable } = useSourceTableActions()

  const [conflict, setConflict] = useState(false)

  const handleClose = () => {
    onClose()
    setConflict(false)
  }

  const handleDelete = () => {
    if (!table) {
      return
    }

    tryDeleteSourceTable(table.id, activeSource.id, {
      onConflict: () => setConflict(true),
      onSuccess: () => {
        handleClose()

        const remaining = activeSource.included.source_tables.filter(
          (item) => item.id !== table.id
        )

        history.push({
          search:
            remaining.length > 0 ? `source_table_id=${remaining[0].id}` : ''
        })
      }
    })
  }

  return (
    <SimpleDialog
      actions={
        <>
          <Button onClick={handleClose} variant="text">
            Avbryt
          </Button>
          {!conflict ? (
            <Button color="error" onClick={handleDelete} variant="contained">
              Ta bort
            </Button>
          ) : null}
        </>
      }
      onClose={handleClose}
      open={open}
      title={conflict ? 'Kan inte ta bort' : 'Ta bort tabell?'}
    >
      <Text>
        {conflict ? (
          <>
            Tabellen <b>&quot;{table?.attributes.name}&quot;</b> används i ett
            eller flera input-noder och kan inte tas bort. Ta bort alla
            referenser först.
          </>
        ) : (
          <>
            Är du säker på att du vill ta bort tabellen{' '}
            <b>&quot;{table?.attributes.name}&quot;</b>? Detta kommer också ta
            bort tillhörande kolumner. Åtgärden går inte att ångra.
          </>
        )}
      </Text>
    </SimpleDialog>
  )
}

export default DeleteSourceTableDialog
